export function getTailoredScheduleCode(code, payload) {
    const uniqueCode = payload?.uniqueCode
    if (!code || !uniqueCode) return code

    const tailoredSuffix = `${uniqueCode}`.padStart(4, "0")
    const codeText = `${code}`
    if (codeText.endsWith(`-${tailoredSuffix}`)) return codeText
    if (codeText.endsWith(`-${uniqueCode}`)) {
        return `${codeText.slice(0, -`${uniqueCode}`.length)}${tailoredSuffix}`
    }

    return `${codeText}-${tailoredSuffix}`
}
